export const HEADING_DEFAULTS = {
  padding: '8px 8px 8px 8px', // top right bottom left
  paddingRoot: '8px 30px 8px 30px', // top right bottom left
  margin: '0px 0px 0px 0px', // top right bottom left
  letterSpacing: 'normal',
};
